import { createFileRoute } from "@tanstack/react-router";
import tenantAxiosInstance from "api/tenantAxiosInstance";
import { useGetDefaultsQuery } from "api/TenantSlug/Setting/hooks.ts";
import { AffiliateRegistrationForm } from "components/Forms/AffiliateRegistrationForm/AffiliateRegistrationForm.tsx";
import { AuthPageContainer } from "components/UI/AuthPageContainer/AuthPageContainer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

export const Route = createFileRoute("/$tenantSlug/auth/_layout/registration/")({
    component: TenantRegistrationPage,
});

function TenantRegistrationPage() {
    const { t: tAuth } = usePaldockTranslation("auth.registration");
    const { t: tC } = usePaldockTranslation("common");
    const { tenantSlug } = Route.useParams();
    const getTenantQuery = useGetDefaultsQuery(tenantSlug);

    if (getTenantQuery.data?.tenant) {
        tenantAxiosInstance.setTenantSlugInUrl(getTenantQuery.data.tenant.slug_name);
    }

    return (
        <AuthPageContainer title={tAuth("title")}>
            {getTenantQuery.isSuccess ? (
                <AffiliateRegistrationForm tenant={getTenantQuery.data.tenant} />
            ) : (
                tC("loading")
            )}
        </AuthPageContainer>
    );
}
